var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[(_vm.templateNumber === 1)?_c('BodyRegister1',{attrs:{"items":_vm.items}}):(_vm.templateNumber === 2)?_c('BodyRegister2',{attrs:{"items":_vm.items}}):(_vm.templateNumber === 3)?_c('BodyRegister3',{attrs:{"items":_vm.items}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }